import { useEffect, useState } from 'react'

import { Modal, Spinner, Center, Box } from '@sequencehq/core-components'
import { PdfViewer } from '@sequencehq/pdf-viewer'
import { useGeneratePDF } from 'CreditNotes/hooks/useGeneratePDF.tsx'
import { CreditNoteStatus } from 'CreditNotes/types'

export const PdfPreviewDrawer = ({
  closeModal,
  creditNoteId,
  creditNoteStatus,
  creditNoteNumber
}: {
  closeModal: () => void
  creditNoteId: string
  creditNoteStatus: CreditNoteStatus
  creditNoteNumber: string | undefined
}) => {
  const { generateLocalPDF, generateRemotePDF } = useGeneratePDF()

  const [data, setData] = useState<Blob | undefined>()

  const fileName = creditNoteNumber
    ? `${creditNoteNumber}.pdf`
    : 'Credit note.pdf'

  // biome-ignore lint/correctness/useExhaustiveDependencies: modal open only
  useEffect(() => {
    const loadData = async () => {
      // Draft credit notes have no server-side PDF yet, so render one locally.
      const blob =
        creditNoteStatus === 'DRAFT'
          ? await generateLocalPDF({ id: creditNoteId })
          : await generateRemotePDF({ id: creditNoteId })

      setData(blob)
    }

    void loadData()
  }, [])

  return (
    <Modal
      isOpen
      variant="drawer"
      onClose={closeModal}
      data-testid="creditNotes.pdf-preview.drawer"
    >
      <Modal.Header showCloseButton>PDF Preview</Modal.Header>
      <Modal.Content padding={0}>
        <Center width="100%" height="100%" position="relative">
          {data ? (
            <Box
              width="100%"
              height="100%"
              position="absolute"
              top="0"
              left="0"
            >
              <PdfViewer
                data={data}
                fileName={fileName}
                data-testid="creditNotes.pdf-preview.pdf-viewer"
              >
                <PdfViewer.StandardControls />
              </PdfViewer>
            </Box>
          ) : (
            <Spinner />
          )}
        </Center>
      </Modal.Content>
    </Modal>
  )
}
